import $ from 'jquery';
import gsap from 'gsap';
import './vendor';
import './vendor/ua-parser';
import './helpers';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import helpers from './helpers';
import {ieFix} from './vendor/ie-fix';
import {vhFix} from './vendor/vh-fix';
import {actualYear} from './modules/actualYear';
import header from './components/header';
import share from './components/share';
import lazyLoading from './modules/lazyLoading';
import scrollToAnchor from './modules/scrollToAnchor';
import scrollspy from './modules/scrollspy';
import combinedAnimation from './components/combined-animation';
import watchScroll from './components/watchScroll';
import chartCourse from './components/chartCourse';
import {socialInit} from './components/social';
import analytics from './components/analytics';
// import videoLoader from './modules/videoLoader';

ScrollTrigger.config({
	// Default is "resize,visibilitychange,DOMContentLoaded,load",
	// We remove "resize,load" from the list to fix scroll to top on mobile devises:
	autoRefreshEvents: 'visibilitychange,DOMContentLoaded',
});

gsap.registerPlugin(ScrollTrigger);

window.$ = $;
window.jQuery = $;
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;

function init() {
	ieFix();
	vhFix();
	actualYear();

	watchScroll.init();
	scrollToAnchor.init();
	scrollspy.init();

	combinedAnimation.init();
	header.init();
	share.init();
	socialInit();
	lazyLoading.init();
	chartCourse.init();

	/* eslint-disable */
	async function allVideosHasBeenLoaded() {
		// Select all videos to a nodelist
		const allVideosElements = document.querySelectorAll('video');

		// If there's at least one node
		if (allVideosElements.length > 0) {
			// Transform to an array
			let allVideosElementsArr = Array.from(allVideosElements);

			// Wait until all videos will be loaded
			Promise.all(allVideosElementsArr.map(function (video) {
				return new Promise(function (resolve, reject) {
					video.addEventListener('loadeddata', function () {
						resolve();
					});
				});
			}))
				.then(function () {
					// All videos are loaded and we can resolve the "allVideosHasBeenLoaded" promise
					return Promise.resolve();
				});
		} else {
			return Promise.resolve();
		}
	}

	// window.addEventListener('load', async () => {
	// 	await allVideosHasBeenLoaded();
	// 	// console.log('Load fired')
	// 	setTimeout(() => {
	// 		ScrollTrigger.refresh();
	// 	}, 1500);
	// });

	const str = window.location.pathname.replace('feminizm-v-rossii', '')
		.split('/')
		.join('');
	if(str === '') {
		const ymOptions = {
			referer: location.href,
			title: document.title,
		};

		analytics.init(undefined, ymOptions);
	}
	if (str.length > 0 && $(`#${str}`).length > 0) {
		// helpers.scrollTo($(`#${str}`), 0, 0);

		document.title = window.data.menu[str]?.name;
		document.querySelector('meta[name="description"]')
			.setAttribute('content', window.data.menu[str]?.description);

		setTimeout(() => {
			helpers.scrollTo($(`#${str}`), 0, 0);
		}, 1000)
	}
}

init();
/* eslint-enable */
